'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'TOGGLER',
	name: 'Toggler',
	allowedSections: ['main', 'header', 'footer'],
	disallowedChildren: [],
	icon: 'fal fa-toggle-off',
	category: 'Dropdown',
	props: [{
		name: 'label',
		inputType: 'text',
		label: 'Label text',
		default: 'Click me'
	}, {
		name: 'hideLabel',
		inputType: 'checkbox',
		label: 'Hide label',
		default: false
	}, {
		name: 'iconClosed',
		inputType: 'icon',
		label: 'Choose icon when dropdown is closed',
		default: false
	}, {
		name: 'iconClosedSize',
		inputType: 'text',
		label: 'Set size on above icon',
		default: '2em'
	}, {
		name: 'iconClosedColor',
		inputType: 'color',
		label: 'Set color on above icon',
		default: '#808080'
	}, {
		name: 'iconOpen',
		inputType: 'icon',
		label: 'Choose icon when dropdown is open',
		default: false
	}, {
		name: 'iconOpenSize',
		inputType: 'text',
		label: 'Set size on above icon',
		default: '2em'
	}, {
		name: 'iconOpenColor',
		inputType: 'color',
		label: 'Set color on above icon',
		default: '#808080'
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass'])
};